import styled from 'styled-components'

import type { T_HeadingProps } from './heading'

const SC_BaseHeading = styled((props: T_HeadingProps) => {
  const {
    level,
    centered,
    children,
    ...restProps
  } = props

  switch (level) {
    case 1: return <h1 {...restProps}>{children}</h1>
    case 2: return <h2 {...restProps}>{children}</h2>
    case 3: return <h3 {...restProps}>{children}</h3>
    case 4: return <h4 {...restProps}>{children}</h4>
    case 5: return <h5 {...restProps}>{children}</h5>
    case 6: return <h6 {...restProps}>{children}</h6>
  }
})`
  width: 100%;
  margin: 0;
  text-align: ${(p) => p.centered ? 'center' : 'left'};
`

export const SC_H1 = styled(SC_BaseHeading)`
  font-size: 24px;
  line-height: 24px;
`

export const SC_H2 = styled(SC_BaseHeading)`
  font-size: 20px;
  line-height: 20px;
`

export const SC_H3 = styled(SC_BaseHeading)`
  font-size: 18px;
  line-height: 18px;
`

export const SC_H4 = styled(SC_BaseHeading)`
  font-size: 16px;
  line-height: 16px;
`

export const SC_H5 = styled(SC_BaseHeading)`
  font-size: 14px;
  line-height: 14px;
`

export const SC_H6 = styled(SC_BaseHeading)`
  font-size: 12px;
  line-height: 12px;
`
